export const setClockOffset = (offset: number): void => {
  clockOffset = offset
}

/** Current time in ms, corrected for this device's clock skew vs. the server. */
export const correctedNow = (): number => Date.now() + clockOffset

/** A server-clock instant in ms, moved onto this device's clock. */
export const toDeviceTime = (serverMs: number): number => serverMs - clockOffset

// server time minus this device's clock, in ms; 0 until the client measures it
let clockOffset = 0
